/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/
import { ExhaustiveError, RandoriEntityTypeError } from '@/utilities/r-error'

import type { EntityType } from '../entity-types'

export const getDisplayPluralByType = (entityType: EntityType): string => {
  switch (entityType) {
    case 'action':
      return 'Actions'
    case 'activity_configuration':
      return 'Activity Configurations'
    case 'activity_instance':
      return 'Activities'
    case 'artifact':
      return 'Artifacts'
    case 'asset':
      return 'Assets'
    case 'bar':
      return 'Bart Requests (Global)'
    case 'blueprint':
      return 'Runbook Blueprints (Global)'
    case 'characteristicRule':
      return 'Characteristic Rules'
    case 'detection_target':
      return 'Targets'
    case 'exception_policy':
      return 'Exception Policies'
    case 'globalArtifact':
      return 'Artifacts'
    case 'globalHostname':
      return 'Hostnames'
    case 'globalIps':
      return 'IP Addresses'
    case 'globalNetwork':
      return 'Networks'
    case 'globalService':
      return 'Global Services'
    case 'hostname':
      return 'Hostnames'
    case 'implant':
      return 'Implants'
    case 'integrations':
      return 'Integrations'
    case 'ip':
      return 'IP Addresses'
    case 'network':
      return 'Networks'
    case 'organization':
      return 'Organizations'
    case 'peer':
      return 'Peer Groups'
    case 'poc':
      return 'POCs'
    case 'policy':
      return 'Policies'
    case 'redirector':
      return 'Redirectors'
    case 'report':
      return 'Reports'
    case 'runbook':
      return 'Runbooks'
    case 'savedViews':
      return 'Saved Views'
    case 'service':
      return 'Services'
    case 'serviceRule':
      return 'Service Rules'
    case 'serviceSuggestion':
      return 'Suggestions'
    case 'social':
      return 'Social Entities'
    case 'source':
      return 'Sources'
    case 'target':
      return 'Targets'
    case 'term':
      return 'Terms'
    case 'topLevelDetection':
      return 'Detections'
    case 'hostnameForIp':
      return 'Hostnames'
    case 'ipForHostname':
      return 'IP Addresses'
    case 'ipForNetwork':
      return 'IP Addresses'
    case 'authorization_policy':
      return 'Authorization Policies'
    case 'applicable_activity':
    case 'entity_for_activity_instance':
    case 'event_log':
    case 'perspective':
      throw new RandoriEntityTypeError({ entityType })
    case 'bdo_detection':
      return 'Detections'
    default:
      throw new ExhaustiveError(entityType)
  }
}
